import { IMediaContainer } from './IMediaContainer';
import { RenderDevice } from './RenderDevice';
import { ResourcePool } from './ResourcePool';
import { TtfFont } from './TtfFont';
import { TtfFontResource } from './TtfFontResource';
import { TtfFontUtils } from './TtfFontUtils';
import { IAssetsUrlFormatter } from '../helpers/assets-url.formatter';

export class TtfFontResourcePool extends ResourcePool<TtfFontResource> {
  private readonly _renderDevice: RenderDevice;
  private readonly _fontUtils: TtfFontUtils;

  constructor(renderDevice: RenderDevice, assetsUrlFormatter?: IAssetsUrlFormatter) {
    super(assetsUrlFormatter);
    this._renderDevice = renderDevice;
    this._fontUtils = new TtfFontUtils();
  }

  createResource(resourceId: string): TtfFontResource {
    return new TtfFontResource(resourceId);
  }

  public get requiresMediaContainer(): boolean {
    return false;
  }

  async loadResourceData(
    resource: TtfFontResource,
    xml: Element,
    _: IMediaContainer | null
  ): Promise<void> {
    await this._fontUtils.registerFontFromXml(xml, this.assetsUrlFormatter); // create css for this font

    resource.construct(new TtfFont(this._renderDevice));
  }

  getResource(resourceId: string): TtfFontResource {
    let result = this.resources.get(resourceId);
    if (!result) {
      result = new TtfFontResource(resourceId);
      result.construct(new TtfFont(this._renderDevice));

      this.resources.set(resourceId, result);

      this._fontUtils.registerFontFromPath(resourceId); // create css for this font
    }
    return result;
  }
}
